import { useCallback, useEffect, useState } from "react";
import { Card, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Block from "../../components/Block/Block";
import { Icon } from "../../components";
import { getGrnListApi, getGrnListExport } from "../../services/GrnService";
import { toast } from "react-toastify";
import Pagination from "../Constant/Pagination";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import { CancelRequest } from "../../services/AxiosInstance";
import BarLoader from "../../components/Loader/BarLoader";
import { OnlyStoreManager } from "../../router/permission";
import { useSelector } from "react-redux";
import GrnImportModal from "./GrnImportModal";
import { formatDateTimeWithAdd5Hours } from "../../utilities";
import { format } from "date-fns";
import { Spinner } from "react-bootstrap";
import { FaSort, FaSortUp, FaSortDown, FaDownload } from "react-icons/fa";
function GRNListPage() {
  const navigate = useNavigate();
  const role = useSelector((state) => state.auth.user?.role || "user");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [grnImportModal, setgrnImportModal] = useState(false);
  const [exportloading, setExportloading] = useState(false);
  const [filter, setFilter] = useState({
    page: 1,
    page_size: 10,
    query: "",
  });
  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await getGrnListApi(filter);
      setData(response.data.results);
      setTotal(response.data.count);
    } catch (error) {
      toast.error(error.response?.data?.message);
      setData([]);
    } finally {
      setIsLoading(false);
    }
  }, [filter]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleToggleGrnImportModal = () => {
    setgrnImportModal(!grnImportModal);
  };

  const handlePagination = (page) => {
    const newPage = page.selected + 1;
    setFilter((prev) => ({ ...prev, page: newPage }));
  };

  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setFilter((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };

  const handleAfterGrnImportSubmit = () => {
    handleToggleGrnImportModal();
    fetchData();
  };

  const handleExport = () => {
    setExportloading(true);
    getGrnListExport(filter)
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "GRN.xlsx";

        // Append to DOM to make it more consistent
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setExportloading(false);
      });
  };
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sorted = [...data].sort((a, b) => {
      const valA = a[key];
      const valB = b[key];

      if (!isNaN(valA) && !isNaN(valB)) {
        return direction === "asc" ? valA - valB : valB - valA;
      }
      if (!isNaN(Date.parse(valA)) && !isNaN(Date.parse(valB))) {
        return direction === "asc"
          ? new Date(valA) - new Date(valB)
          : new Date(valB) - new Date(valA);
      }
      return direction === "asc"
        ? String(valA).localeCompare(String(valB))
        : String(valB).localeCompare(String(valA));
    });

    setData(sorted);
  };

  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <FaSort className="sort-icon neutral" />;
    }
    return sortConfig.direction === "asc" ? (
      <FaSortUp className="sort-icon active" />
    ) : (
      <FaSortDown className="sort-icon active" />
    );
  };

  return (
    <div>
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">GRN List</Block.Title>
            <nav>
              <ol className="breadcrumb breadcrumb-arrow mb-0">
                <li className="breadcrumb-item">
                  <Link to="/">Dashboard</Link>
                </li>
                {/* <li className="breadcrumb-item"><Link to="/user-manage/user-list">User Manage</Link></li> */}
                <li className="breadcrumb-item active" aria-current="page">
                  GRN List
                </li>
              </ol>
            </nav>
          </Block.HeadContent>
          {OnlyStoreManager.includes(role) && (
            <Block.HeadContent>
              <ul className="d-flex">
                {/* Import Users Button */}
                <li>
                  <Button
                    variant="outline-secondary"
                    className="d-none d-md-inline-flex me-2"
                    onClick={handleToggleGrnImportModal}
                  >
                    <Icon name="upload" />
                    <span>Import GRN</span>
                  </Button>
                </li>
                <li>
                  <Button
                    className="d-md-none"
                    size="md"
                    variant="primary"
                    onClick={() => navigate("/grn-add")}
                  >
                    <Icon name="plus" />
                    <span>Add</span>
                  </Button>
                </li>
                <li>
                  <Button
                    className="d-none d-md-inline-flex"
                    variant="primary"
                    onClick={() => navigate("/grn-add")}
                  >
                    <Icon name="plus" />
                    <span>Add GRN</span>
                  </Button>
                </li>
              </ul>
            </Block.HeadContent>
          )}
        </Block.HeadBetween>
      </Block.Head>

      <Block>
        <Card>
          <div className="data-table-wrapper">
            <div className="d-flex justify-content-between p-3">
              <div>
                <DebounceSearchInput handleSearchChange={handleSearchChange} />
              </div>

              <button
                className="btn btn-success d-flex align-items-center gap-1 align-self-center"
                onClick={handleExport}
                disabled={exportloading || !data?.length > 0}
              >
                {exportloading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  <FaDownload />
                )}
                Export
              </button>
            </div>
          </div>
          <div className="table-responsive">
            {isLoading ? (
              <div className="text-center my-4">
                <BarLoader color="#255D5C" size={50} />
              </div>
            ) : (
              <>
                <table className="table table-hover border-less fs-6">
                  <thead className="table-light custom-thead">
                    <tr>
                      <th
                        onClick={() => handleSort("grn_number")}
                        style={{ cursor: "pointer" }}
                      >
                        GRN Number {renderSortIcon("grn_number")}
                      </th>
                      <th
                        onClick={() => handleSort("vendor.name")}
                        style={{ cursor: "pointer" }}
                      >
                        Vendor {renderSortIcon("vendor.name")}
                      </th>
                      <th
                        onClick={() => handleSort("received_by.name")}
                        style={{ cursor: "pointer" }}
                      >
                        Received By {renderSortIcon("received_by.name")}
                      </th>
                      <th
                        onClick={() => handleSort("received_date")}
                        style={{ cursor: "pointer" }}
                      >
                        Received Date {renderSortIcon("received_date")}
                      </th>
                      <th
                        onClick={() => handleSort("invoice_number")}
                        style={{ cursor: "pointer" }}
                      >
                        Invoice Number {renderSortIcon("invoice_number")}
                      </th>
                      <th
                        onClick={() => handleSort("created_at")}
                        style={{ cursor: "pointer" }}
                      >
                        Created At {renderSortIcon("created_at")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center py-4">
                          No GRN founds.
                        </td>
                      </tr>
                    ) : (
                      data.map((row, index) => (
                        <tr key={index} className="align-middle">
                          <td>
                            <Link to={`/grn/${row.id}`}>
                              <strong>{row.grn_number}</strong>
                            </Link>
                          </td>
                          <td>
                            {row.vendor ? (
                              <div className="d-flex flex-column">
                                {/* <Link to={`/vendor/${row.vendor.id}`}> */}
                                {row.vendor.name}
                                {/* </Link> */}
                              </div>
                            ) : (
                              "N/A"
                            )}
                          </td>
                          <td>
                            <div className="d-flex flex-column">
                              {/* <Link to={`/user/${row.received_by.id}`}> */}
                              {row.received_by.name}
                              {/* </Link> */}
                            </div>
                          </td>
                          <td>
                            {row.received_date
                              ? format(row?.received_date, "dd MMM yyy")
                              : "-"}
                          </td>
                          <td>{row.invoice_number || "N/A"}</td>
                          <td>
                            {row.created_at
                              ? formatDateTimeWithAdd5Hours(row?.created_at)
                              : "-"}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>

                {/* Pagination below table */}
                <div className="mt-3">
                  <Pagination
                    currentPage={filter.page}
                    recordsPage={filter.page_size}
                    dataLength={total}
                    handlePagination={handlePagination}
                  />
                </div>
              </>
            )}
          </div>
        </Card>
      </Block>

      <GrnImportModal
        visible={grnImportModal}
        onClose={handleToggleGrnImportModal}
        afterSubmit={handleAfterGrnImportSubmit}
      />
    </div>
  );
}

export default GRNListPage;
